// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"135":"group-auth","594":"about"}[chunkId] || chunkId) + "." + {"135":"0394a80b","335":"4982918c","496":"aa44681f","594":"fb628037","842":"14c184b1","904":"413a361a"}[chunkId] + ".js";
};